import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public isMenuOpen: boolean = true;

  constructor() { }

  public toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
